import { alertDetails, actionFilter } from "./interfaces";

export const actionFilters: actionFilter[] = [
  { id: 1, reason: 'Action Alert', status: false, icon: 'exclamation-triangle', iconColor: '#ff9800' },
  { id: 2, reason: 'Sales Opportunity', status: false, icon: 'dollar-sign', iconColor: 'green' },
  { id: 3, reason: 'Attrition Risk', status: false, icon: 'asterisk', iconColor: '#e42f2f' },
  { id: 4, reason: 'WOW', status: false, icon: 'star', iconColor: '#FFD700' },
  { id: 5, reason: 'Perfect Score', status: false, icon: 'check', iconColor: 'green' },
  { id: 6, reason: 'New', status: false, icon: 'bell', iconColor: '#ff9800' },
  { id: 7, reason: 'Pending', status: false, icon: 'bell', iconColor: '#039BE5' },
  { id: 8, reason: 'Resolved', status: false, icon: 'thumbs-up', iconColor: 'green' },
  { id: 9, reason: 'N/A', status: false, icon: 'bell', iconColor: '#e7e7e7' },
  { id: 10, reason: 'No Action Needed', status: false, icon: 'minus-circle', iconColor: '#7ED321' },
  { id: 11, reason: 'Unread', status: false, icon: 'bookmark', iconColor: 'black' },
  { id: 12, reason: 'Read', status: false, icon: 'bookmark', iconColor: '#e7e7e7' },
]